import { AdMob, InterstitialAdPluginEvents } from "@capacitor-community/admob";

export default async function showPopupAdv() {
  try {
    AdMob.addListener(InterstitialAdPluginEvents.Loaded, (info) => {
      // Subscribe prepared interstitial
    });

    const options = {
      adId: "ca-app-pub-8301863454400334/2767312601",
      // isTesting: true
      // npa: true
    };

    await AdMob.prepareInterstitial(options);
    await AdMob.showInterstitial();
  } catch (e) {
    window.popupAlert(e.message);
  }
}
